module.exports = __webpack_public_path__ + "img/arrow_drop_down_3.bef47904.svg";